module.exports = __webpack_public_path__ + "img/partner15.a4da22cb.png";